import React, { useEffect, useState } from 'react';

export default function BackgroundImage({ src, lqip, style = {}, className = '', children, placeholderColor = '#111827', alt = '', ...rest }) {
  // const [loaded, setLoaded] = useState(false);
  const [showImage, setShowImage] = useState(false);

  useEffect(() => {
    // setLoaded(false);
    setShowImage(false);
    if (!src) return;
    const img = new Image();
    img.src = src;
    img.onload = () => {
      // setLoaded(true);
      // let the browser paint the low-res first, then transition
      requestAnimationFrame(() => setShowImage(true));
    };
  }, [src]);

  const containerBase = {
    position: 'relative',
    width: '100%',
    minHeight: '100vh',
    overflowX: 'hidden',
    overflowY: 'auto',
    ...style,
  };

  const layerBase = {
    position: 'absolute',
    inset: 0,
    zIndex: 0,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    transition: 'opacity 500ms ease, filter 500ms ease',
    pointerEvents: 'none',
  };

  const lqipLayer = {
    ...layerBase,
    backgroundColor: placeholderColor,
    backgroundImage: lqip ? `url("${lqip}")` : undefined,
    filter: showImage ? 'blur(10px)' : 'blur(10px)',
    opacity: showImage ? 0 : 1,
  };

  const hiResLayer = {
    ...layerBase,
    backgroundImage: src ? `url("${src}")` : undefined,
    filter: showImage ? 'blur(0px)' : 'blur(20px)',
    opacity: showImage ? 1 : 0,
  };

  const contentLayer = {
    position: 'relative',
    zIndex: 1,
  };

  return (
    <div role="img" aria-label={alt} className={className} style={{ ...containerBase, isolation: 'isolate' }} {...rest}>
      <div style={lqipLayer} data-background-layer="true" />
      <div style={hiResLayer} data-background-layer="true" />
      <div style={contentLayer} data-content-layer="true">{children}</div>
    </div>
  );
}
